export const SHOW_MANAGER_APPROVAL = 'SHOW_MANAGER_APPROVAL'
export const HIDE_MANAGER_APPROVAL = 'HIDE_MANAGER_APPROVAL'
export const SETUP_MANAGER_APPROVAL = 'SETUP_MANAGER_APPROVAL'
